import { AbstractDTO } from "@signature-it/ngx-generic/models";

export class CartTotalQuantityDTO extends AbstractDTO {
    total_quantity: number;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.total_quantity = Number(attributes['total_quantity']) || 0;
    }

}
